module.exports = __webpack_public_path__ + "static/media/img_discovery.339c2dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_discovery.png
// module id = 387
// module chunks = 4